export const DEFAULT_IMG =
	'https://res.cloudinary.com/sponsor-circle/image/upload/v1669318091/hjj4q8puzpxxlhwqpi1y.png';
export const DEFAULT_PDF_IMG =
	'https://res.cloudinary.com/sponsor-circle/image/upload/v1669318485/hufhbqwujxzrztnantxu.jpg';

export const DEFAULT_SOCIAL_MEDIA_IMG =
	'https://res.cloudinary.com/sponsor-circle/image/upload/v1673984929/e23zyxwzwtgbxvzhjhcf.png';

export const months = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec',
];

export const MAP_IMG =
	'https://res.cloudinary.com/sponsor-circle/image/upload/v1674280559/tiqsgzx86q72blmlwrei.webp';

export const CLOUDINARY_DIR =
	'https://res.cloudinary.com/sponsor-circle/image/upload/';
